import { settingActionTypes as types } from 'src/redux/actions/settingActions';

const initialState = {
  themeColor: '#001e38'
};

export default function settingReducer(state = initialState, { type, data, error, payload }) {
  switch (type) {
    case types.CHANGE_THEME:
      return {
        ...state,
        themeColor: payload
      }
    default:
      return state;
  }
}
